import {
  FILTER_APPLIED,
  FILTER_REMOVED,
} from '../../analytics/analyticsEvents';

import { useAnalyticsData } from '../../../hooks/useAnalyticsData';
import { dispatchAnalyticsEvent } from '../../analytics/analyticsEvents';

export const useFacetAnalyticsEvent = ({ value }) => {
  const { pageType, facetContext } = useAnalyticsData();

  return () => {
    const { applied } = facetContext;

    const {
      filterCombination: currentFilterCombination,
      filterCombinationNvals: currentFilterCombinationNvals,
    } = applied;

    const { facetName = '', label, name, selected, trackingId } = value;

    const appliedFilter = `${facetName}:${label || name}`.toLowerCase();
    const appliedFilterNval = `${trackingId}`;

    let filters = [];
    let nvalFilters = [];

    if (currentFilterCombination) {
      filters = currentFilterCombination.split('|').filter(Boolean);
      nvalFilters = currentFilterCombinationNvals.split('|').filter(Boolean);
    }

    if (selected) {
      const index = filters.indexOf(appliedFilter);
      const nvalIndex = nvalFilters.indexOf(appliedFilterNval);
      if (index > -1) filters.splice(index, 1);
      if (nvalIndex > -1) nvalFilters.splice(nvalIndex, 1);
    } else {
      filters.push(appliedFilter);
      nvalFilters.push(appliedFilterNval);
    }

    const filterCombination = filters.join('|');
    const filterCombinationNvals = nvalFilters.join('|');

    return dispatchAnalyticsEvent(selected ? FILTER_REMOVED : FILTER_APPLIED, {
      pagetype: pageType,
      filterCombination,
      filterCombinationNvals,
      appliedFilter,
      appliedFilterNval,
    });
  };
};
